import React from "react";

const Input = ({
  title,
  value,
  setValue,
  placeholder = '',
  type = 'text',
  className = '',
  disable = false,
  rows=3,
  required = false
}) => (
  <div className={className}>
    <label>{title} {required && <span style={{ color: 'red' }}>*</span>}</label>
    {
      type == "textarea" ? (
        <textarea
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={placeholder}
          rows={rows}
          disabled={disable}
        ></textarea>
      )
      : (
        <input
          type={type}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={placeholder}
          disabled={disable}
        />
      )
    }
  </div>
);

export default Input;